class AwakeAsleepIndicatorController {

    constructor() {
        this.view = new AwakeAsleepIndicatorView();
        this.model = plannerApplication.studyPlannerProfile.getDailyRoutine();
        this.onUpdated();
    }

    onUpdated() {
        let hoursUtilised = Math.round(plannerApplication.studyPlannerProfile.averageUtilisedHours());

        let hoursFree = this.model.getHoursUp() - hoursUtilised;
        if (hoursFree < 0) {
            hoursFree = 0;
        }
        if (hoursUtilised + hoursFree > 24) {
            hoursUtilised = 24 - hoursFree;
        }
        let hoursAsleep = 24 - hoursUtilised - hoursFree;

        this.view.occupiedTime.updateHours(hoursUtilised);
        this.view.freeTime.updateHours(hoursFree);
        this.view.asleepTime.updateHours(hoursAsleep);
    };
}
